var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useDeliveryPickup } from "@hooks/api";
import Map from "./Map";
import List, { ListItemSkeleton } from "./List";
import { ErrorBox } from "@components/ui";
import s from "./Pickup.module.css";
import { useGeolocation } from "@hooks/geolocation";
var PickupPicker = function () {
    var coords = useGeolocation().coords;
    var _a = useState(-1), selected = _a[0], setSelected = _a[1];
    var _b = useState(false), loaded = _b[0], setLoaded = _b[1];
    var _c = useDeliveryPickup(), getDeliveryPickups = _c[0], _d = _c[1], data = _d.data, loading = _d.loading, error = _d.error;
    useEffect(function () {
        getDeliveryPickups({ coords: coords });
    }, [coords]);
    useEffect(function () {
        if (!loaded && data && data.length > 0) {
            setLoaded(true);
        }
    }, [data]);
    if (error) {
        return _jsx(ErrorBox, {}, void 0);
    }
    var _data = useMemo(function () { return (data ? data : []); }, [data]);
    return (_jsxs("div", __assign({ className: "h-full sm:flex sm:flex-row-reverse" }, { children: [_jsx("div", __assign({ className: "h-1/2 sm:h-full sm:w-2/3" }, { children: _jsx(Map, { locations: _data, selected: selected, setSelected: setSelected, coords: coords }, void 0) }), void 0),
            _jsx("div", __assign({ className: s.list }, { children: loading && !loaded ? (_jsxs(_Fragment, { children: [_jsx(ListItemSkeleton, {}, void 0),
                        _jsx(ListItemSkeleton, {}, void 0),
                        _jsx(ListItemSkeleton, {}, void 0),
                        _jsx(ListItemSkeleton, {}, void 0)] }, void 0)) : (_jsx(List, { locations: _data, selected: selected, setSelected: setSelected }, void 0)) }), void 0)] }), void 0));
};
export default PickupPicker;
